function Message(state, text)
{
	this.state = state;
	
	this.text = text;
}

export default Message;
